/* eslint-disable react/require-default-props */
/* eslint-disable react/prefer-stateless-function */
/* eslint-disable no-unneeded-ternary */

import React from 'react';
import ReactModal from 'react-modal';

import ICO_CLOSE from 'assets/images/close-btn-black.svg';

import 'styles/common/pin-modal.scss';

const PinModal = ({ additionalClass, children, displayFooter, displayXclose, leftButtonText, message, onLeft, onRight, onXclick, rightButtonText, title }) => (
  <ReactModal
    isOpen
    closeTimeoutMS={0}
    contentLabel={title}
    shouldCloseOnOverlayClick
    role="dialog"
    style={{ overlay: { zIndex: 500 } }}
    className={{ base: 'PIN', afterOpen: '', beforeClose: '' }}
    ariaHideApp={false}
  >
    <div data-bem="PinModal__content" className={`pin-modal ${additionalClass ? additionalClass : ''}`}>
      <div className="modal-body">
        {displayXclose && (
          <span className="close-btn" role="button" tabIndex="0" onClick={onXclick}>
            <img src={ICO_CLOSE} alt={title} />
          </span>
        )}
        <h2 className="modal-title">{title}</h2>
        <div className="modal-content">
          {message}
          <div className="any-children-content"> {children}</div>
        </div>
        {displayFooter && (
          <div className="modal-footer">
            <button className="btn btn-link" tabIndex={0} onClick={onLeft}>
              {leftButtonText}
            </button>
            <button className="btn btn-violet" tabIndex={0} onClick={onRight}>
              {rightButtonText}
            </button>
          </div>
        )}
      </div>
    </div>
  </ReactModal>
);

export default PinModal;
